import styled from 'styled-components';

import Button from '@components/Button/next';

export const Container = styled.div`
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  z-index: 100000;
  transition: all 0.15s;
  background-color: rgba(0, 0, 0, 0.6);

  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Wrapper = styled.div`
  height: 189px;
  width: 380px;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
`;
export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.D400};
`;
export const Description = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.D400};
  padding: 20px 0 20px;
  text-align: center;
`;
export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
`;
export const EvaluationButton = styled(Button)`
  width: 204px;
  height: 40px;
  align-self: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;
export const CloseButton = styled(Button)`
  width: 204px;
  height: 40px;
  align-self: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;
